import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saInterCuIntraFreqHandoutChartConfig } from '../chartConfigs';

interface InterCuIntraFreqHandoutSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuIntraFreqHandoutSaEcharts: React.FC<InterCuIntraFreqHandoutSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saInterCuIntraFreqHandoutChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default InterCuIntraFreqHandoutSaEcharts;
